/**
 * Copyright 2026 Bluecircle Technologies Pvt Limited. All rights reserved.
 *
 * This software and its source code are the proprietary and confidential
 * intellectual property of Bluecircle Technologies Pvt Limited. Unauthorized
 * copying, reproduction, distribution, modification, public display, or use
 * of this software, in whole or in part, is strictly prohibited without the
 * prior written permission of Bluecircle Technologies Pvt Limited.
 *
 * Portions derived from Grist (Copyright Grist Labs), used under the Apache
 * License, Version 2.0. See the NOTICE file for details.
 */

import { ExternalAttachmentBanner } from "app/client/components/ExternalAttachmentBanner";
import { VersionUpdateBanner } from "app/client/components/VersionUpdateBanner";
import { AppModel } from "app/client/models/AppModel";
import { DocPageModel } from "app/client/models/DocPageModel";

import { dom } from "grainjs";

export function buildHomeBanners(app: AppModel) {
  return dom.create(VersionUpdateBanner, app);
}

export function buildDocumentBanners(docPageModel: DocPageModel) {
  return [
    dom.create(VersionUpdateBanner, docPageModel.appModel),
    dom.create(ExternalAttachmentBanner, docPageModel),
  ];
}
